import React, {useEffect, useState} from "react";
import { API } from "common/config-api"; // jsconfig.json
import api from 'api';
import JsBarcode from 'jsbarcode'
import { Link, useNavigate, useParams } from 'react-router-dom';


const UserMembershipCard = () => {

    const {userCode} = useParams();
    const [msg, setMsg] = useState("xxxx회원님");
    let imageUrl = "";

    if(userCode){
        console.log("userCode", userCode);
        const canvas = document.createElement('canvas');
        JsBarcode(canvas, userCode, { height: 80, displayValue: false });
        imageUrl = canvas.toDataURL('image/png');
    }

    useEffect(() => {
      const mainElement = document.getElementById("main");
      if (mainElement) { mainElement.style.marginTop = "0"; mainElement.style.marginLeft = "0";}
      const headElement = document.getElementById("header");
      if (headElement) { headElement.remove();}
      const footElement = document.getElementById("footer");
      if (footElement) { footElement.remove();}
      const sidebarElement = document.getElementById("sidebar");
      if (sidebarElement) { sidebarElement.remove();}
      
    });


    return (
      <>

<div className="outer-container">
  <div className="inner-container">
    <div id="container">
      <div id="first">
        <div>
            텍스트 영역
            <br />
            xxxxx님 언제나 감사함다.
            <br />
            <br />
            www.irosika.com
        </div>
        <img src={imageUrl} alt="바코드" style={{margin: "5vw"}}/>
      </div>
      <div id="second">
        <img src="/images/sikaring_02.png" alt="이미지" />
      </div>
    </div>
  </div>

  <style>
  {`
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
html, body {
  width: 100%;
  height: 100%;
  overflow: hidden; /* 스크롤 방지 */
}
.outer-container {
  position: absolute;
  top: 0;
  left: 3vw; /* 왼쪽 여백 */
  width: 94vw; /* (100 - 3*2) 좌우 마진 반영 */
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
      .inner-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      #container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }
      #first, #second {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        overflow: hidden;
      }
      #first {
        flex-direction: column;
        text-align: center;
      }
      #first img {
        width: 100%;
        max-width: 500px;
        height: auto;
      }
      #second img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
      }

      @media (min-aspect-ratio: 1/1) {
        #container {
          flex-direction: row;
        }
        #first, #second {
          width: 50%;
        }
      }
    `}
  </style>
</div>

      </>
    );

}

export default UserMembershipCard;
